import { CRM_API, RequestHelper } from "utils";

const RUTA = "credenciales-certificacion";

export const CredencialesCertificacionService = (() => {
  const enviar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(RUTA, data);
    });
  };

  return {
    enviar,
  };
})();

